import { BaseMapper } from '@ps/utils';

import { Survey, SurveyStatus } from '../../models/survey.model';
import { SurveyDto } from '../dtos/survey.dto';

// Inbound mapper — maps API response DTOs to domain models.
// Direction: API DTO → Domain model
export class GetSurveysMapper extends BaseMapper<SurveyDto, Survey> {
  public fromDto(survey: SurveyDto): Survey {
    return {
      id: survey.ps_survey_id,
      status: survey.ps_survey_status as SurveyStatus,
      inProgress: survey.in_progress,
      completesRequired: survey.completes_required,
      fielded: survey.fielded,
      avgCpi: survey.acpi,
      currentIr: survey.current_incidence,
      countryName: survey.locale.country_name,
      countryCode: survey.locale.country_code,
      cmp: survey.buyer_company,
      epc: survey.epc,
      title: survey.survey_title,
      companyName: survey.company_name,
      billingId: survey.billing_id,
    };
  }
}
